// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-container {
  background: linear-gradient(135deg, #5b9942 0%, #5b9942 100%) !important;
  padding: 2rem 0 !important;
  margin-top: auto !important;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.copyright-icon {
  color: #ffc022 !important;
  font-size: 1.2rem !important;
}

.copyright-text {
  color: #ffc022 !important;
  font-weight: 600 !important;
  font-size: 0.95rem !important;
  transition: all 0.3s ease !important;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.copyright-text:hover {
  color: #fff !important;
  transform: translateY(-1px) !important;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
}

.footer-right {
  display: flex;
  align-items: center;
}

.footer-nav {
  color: #ffc022 !important;
  font-size: 0.9rem !important;
  font-weight: 500 !important;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column !important;
    gap: 1rem !important;
    text-align: center !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Global/Footer.css"],"names":[],"mappings":"AAAA;EACE,wEAAwE;EACxE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE;IACE,iCAAiC;IACjC,oBAAoB;IACpB,6BAA6B;EAC/B;AACF","sourcesContent":[".footer-container {\n  background: linear-gradient(135deg, #5b9942 0%, #5b9942 100%) !important;\n  padding: 2rem 0 !important;\n  margin-top: auto !important;\n}\n\n.footer-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.footer-left {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.copyright-icon {\n  color: #ffc022 !important;\n  font-size: 1.2rem !important;\n}\n\n.copyright-text {\n  color: #ffc022 !important;\n  font-weight: 600 !important;\n  font-size: 0.95rem !important;\n  transition: all 0.3s ease !important;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.copyright-text:hover {\n  color: #fff !important;\n  transform: translateY(-1px) !important;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);\n}\n\n.footer-right {\n  display: flex;\n  align-items: center;\n}\n\n.footer-nav {\n  color: #ffc022 !important;\n  font-size: 0.9rem !important;\n  font-weight: 500 !important;\n}\n\n@media (max-width: 768px) {\n  .footer-content {\n    flex-direction: column !important;\n    gap: 1rem !important;\n    text-align: center !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
